<template>
  <div class="" v-if="broker != null">
    <div class="text-base">
      As a broker, one of the most common things you will do on {{ getAppName }}
      is adding your clients, and {{ getAppName }} makes the entire process simple, yet powerful.
    </div>

    <div class="text-base mt-4">
      As a quick start, we are going to take you through 3 easy steps for adding your
      very first client.
    </div>

    <div class="mt-12 mb-8 text-center">
      <router-link 
        :to="{
          name  : 'broker-onboard-first-client-one',
          params: {
            brokerId: $route.params.brokerId
          }
        }"
        tag="a" 
        class="bg-blue-500 text-white text-xs uppercase px-12 py-4 rounded-sm hover:bg-blue-600 font-semibold">
        let's Get Started!
      </router-link>
    </div>

    <!-- <div class="mt-1 text-sm text-gray-700">
      Congratulations, you have completed your <span class="text-blue-500">Personalization Tutorial</span>.
    
      If you wish to change any of these settings, you can always do that via clicking on
      <span class="text-green-600 font-semibold">My Settings</span>
      and then
      <span class="text-green-600 font-semibold">Site Appearance</span>.
    
      There are still many more features you can explore on {{ getAppName }} via our
    </div> -->
  </div>
</template>

<script>
  import { EventBus }   from '@/shared/event-bus'
  import TitleSelector  from '@/shared/components/form/TitleSelector'
  import InputText      from '@/shared/components/form/InputText'
  import SubmitButton2  from '@/shared/components/form/SubmitButton2'
  import InputRadio     from '@/shared/components/form/InputRadio'

  import InputDatePickerReadOnly from '@/shared/components/form/InputDatePickerReadOnly'
  
  export default {

    components: {
      TitleSelector,
      InputText,
      SubmitButton2,
      InputDatePickerReadOnly,
      InputRadio
    },

    data () {
      return {
        loading : false,
        broker  : null,
        uploaded: false,

        application : {
          title    : null,
          firstName: null
        }
      }
    },

    created() {
      this.getBroker({
        brokerId: this.$route.params.brokerId
      }, (broker) => {
        this.broker = broker
      })
    },

    methods : {
      updateValue() {

      },
      
      next() {
        // if(this.broker.logo != null) {
          this.$router.push({
            name  : 'broker-onboard-first-client-two',
            params: {
              brokerId : this.broker.id
            }
          })
        // }

        // else {
        //   this.$modal.show('confirm-modal', {
        //     // width : 600,
        //     title  : "Are you sure?",
        //     message: "Are you sure you want to proceed without uploading a logo?",
        //     buttons:[{
        //       label          : 'Yes',
        //       color          : 'green',
        //       loadingViaLocal: true, // a bit of HACK, we want to show loading image when button is clicked, but hard to pass loading prop to a modal
        //       action         : () => {
        //         this.$modal.hide('confirm-modal')
        //         this.$router.push({
        //           name  : 'broker-onboard-personalize-two',
        //           params: {
        //             brokerId : this.broker.id
        //           }
        //         })
        //       }
        //     }, {
        //       label : 'No',
        //       color : 'gray',
        //       action: () => {
        //         this.$modal.hide('confirm-modal')
        //       }
        //     }]
        //   })
        // }
      }
    },
  }
</script>